import { PATHNAMES } from "./pathNameConstants";
import ebay from "../../assets/images/ebay.png";
import AutoTrader from "../../assets/images/AutoTrader.jpg";
import CarGuru from "../../assets/images/CarGurus.png";
import carCom from "../../assets/images/Cars-Com-Logo.png";
import edmuds from "../../assets/images/edmunds-logo.png";
import Kbb from "../../assets/images/ribbonLogo-KBB.png";
import JDpower from "../../assets/images/J.D.-Power.png";
import trueCar from "../../assets/images/TrueCar.png";
import MyPlace from "../../assets/images/MyPlace4parts.png";
import MountainAmerica from "../../assets/images/ribbonLogo-MACU.png";

export const defaultMenuNoListing = [
  {
    id: 1,
    name: "Order Vehicle History Reports",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "Order Vehicle History Reports",
        link: PATHNAMES.VEHICLEHISTORY_REPORTS,
      },
      {
        sid: 2,
        name: "See a Sample Vehicle History Report",
        link: PATHNAMES.VEHICLEHISTORY_SAMPLE_REPORT,
      },
    ],
  },
  {
    id: 2,
    name: "Finding Vehicles",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "How to Buy a Used Car",
        link: PATHNAMES.VEHICLEHISTORY_AUTOSHOPPERS_GUIDE,
      },
    ],
  },
  {
    id: 3,
    name: "The AutoCheck Difference",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "Data Backed by Experian",
        link: PATHNAMES.VEHICLEHISTORY_BACKED_BY_EXPERIAN,
      },
      {
        sid: 2,
        name: "The Patented AutoCheck Score",
        link: PATHNAMES.VEHICLEHISTORY_AUTOCHECK_SCORE,
      },
      {
        sid: 3,
        name: "Vehicle Buyback Protection",
        link: PATHNAMES.VEHICLEHISTORY_BUYBACK_PROTECTION,
      },
      {
        sid: 4,
        name: "VIN Checks for Subscribers",
        link: PATHNAMES.VEHICLEHISTORY_SUBSCRIPTION_BENEFITS,
      },
    ],
  },
];

export const defaultMenu = [
  {
    id: 1,
    name: "Order Vehicle History Reports",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "Order Vehicle History Reports",
        link: PATHNAMES.VEHICLEHISTORY_REPORTS,
      },
      {
        sid: 2,
        name: "See a Sample Vehicle History Report",
        link: PATHNAMES.VEHICLEHISTORY_SAMPLE_REPORT,
      },
    ],
  },
  {
    id: 2,
    name: "Finding Vehicles",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "How to Buy a Used Car",
        link: PATHNAMES.VEHICLEHISTORY_AUTOSHOPPERS_GUIDE,
      },
    ],
  },
  {
    id: 3,
    name: "The AutoCheck Difference",
    link: "#",
    subMenu: [
      {
        sid: 1,
        name: "Data Backed by Experian",
        link: PATHNAMES.VEHICLEHISTORY_BACKED_BY_EXPERIAN,
      },
      {
        sid: 2,
        name: "The Patented AutoCheck Score",
        link: PATHNAMES.VEHICLEHISTORY_AUTOCHECK_SCORE,
      },
      {
        sid: 3,
        name: "Vehicle Buyback Protection",
        link: PATHNAMES.VEHICLEHISTORY_BUYBACK_PROTECTION,
      },
      {
        sid: 4,
        name: "VIN Checks for Subscribers",
        link: PATHNAMES.VEHICLEHISTORY_SUBSCRIPTION_BENEFITS,
      },
      {
        sid: 5,
        name: "Flood Risk Check",
        link: PATHNAMES.VEHICLEHISTORY_FLOOD_RISK_CHECK,
      },
    ],
  },
];

export const partnerDisplay = [
  {
    // Autocheck
    id: "0",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // AutoTrader.com - siteId 7100-7300
    id: "26",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: AutoTrader,
      title: "Proud to be Partnered with AutoTrader",
    },
  },
  {
    // autobytel.com - siteId 1800-1875
    id: "29",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Bank of America - siteId 192
    id: "32",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // cargurus.com - siteId 3812-3816
    id: "43",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: CarGuru,
      title: "Proud to be Partnered with CarGurus.com Discount",
    },
  },
  {
    // cargurus.com - siteId 3812-3816
    id: "44",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: CarGuru,
      title: "Proud to be Partnered with CarGurus.com Discount",
    },
  },
  {
    // carbuyingtips.com - siteId 1311-1339
    id: "48",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // cars.com - siteId 7070-7089
    id: "52",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: carCom,
      title: "Proud to be Partnered with Cars.com",
    },
  },
  {
    // Voucher enabled - siteId 7062-7064
    id: "64",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Savings.com- siteId 4000
    id: "65",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Ford Direct - siteId 3590-3597
    id: "77",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Ebay - siteId 201-239
    id: "90",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: ebay,
      title: "Proud to be Partnered with eBay",
    },
  },
  {
    // Edmunds.com - siteId 6000-6300
    id: "93",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: edmuds,
      title: "Proud to be Partnered with Edmunds",
    },
  },
  {
    // Autocheck - siteId 189
    id: "97",
    menu: defaultMenu,
    headerPanel: undefined,
  },

  {
    // KBB - siteId 5000-5999
    id: "123",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: Kbb,
      title: "Proud to be Partnered with Kelley Blue Book",
    },
  },

  {
    // Google - siteId 1250-1288
    id: "128",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSI BJ's Club - siteId 280-289
    id: "133",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSI Sams Club - siteId 260-269
    id: "134",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSN - siteId 2600-3339
    id: "135",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Military.com - siteId 240-249
    id: "137",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MACU - siteId 3690-3694
    id: "142",
    menu: defaultMenu,
    headerPanel: {
      logo: MountainAmerica,
      title: "Proud to be Partnered with Mountain America Credit Union",
    },
  },
  {
    // NADAguides.com - JD Power - siteId 330-399
    id: "147",
    menu: defaultMenu,
    headerPanel: {
      logo: JDpower,
      title: "Proud to collaborate with J.D. Power",
    },
  },
  {
    // NADAguides.com - JD Power - siteId 1290-1300
    id: "151",
    menu: defaultMenu,
    headerPanel: {
      logo: JDpower,
      title: "Proud to collaborate with J.D. Power",
    },
  },
  {
    // Overture - siteId 800-890
    id: "159",
    menu: defaultMenu,
    headerPanel: {
      logo: JDpower,
      title: "Proud to collaborate with J.D. Power",
    },
  },
  {
    // Progressive.com - siteId 3807-3811
    id: "162",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // WFS Financial - siteId 660-663
    id: "191",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Carsoup.com - siteId 1950-1978
    id: "203",
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // truecar.com - siteId 8900
    id: "209",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: trueCar,
      title: "Proud to be Partnered with TrueCar",
    },
    landingPage: PATHNAMES.VEHICLEHISTORY_TRUECAR,
  },
  {
    // MyPlace4parts - siteId 7500-7546
    id: "210",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: MyPlace,
      title: "Proud to be Partnered with MyPlace4Parts Discount",
    },
  },

  {
    // KBB - siteId 5000-5999
    id: "211",
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: Kbb,
      title: "Proud to be Partnered with Kelley Blue Book",
    },
  },

  {
    //"uid": "212", "name": "TrueCar", "url": "www.TrueCar.com" will be no banner
    id: "212",
    menu: defaultMenuNoListing,
    headerPanel: {
    
    },
  },

  // commenting this section as per Tony's instructions as the fix was a short term one as stg and production were out of sync that time
  /* {
    // truecar.com - siteId 8900
    // This id section is only for staging
    // Because staging and productoni tc_partner_code is
    // out of sync.  So; until it's fixed leaving 212 for staging
    id: '212',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/TrueCar.png',
      title: 'Proud to be Partnered with TrueCar Discount',
    },
  }, */
];
